// extracted by mini-css-extract-plugin
export default {"stars":"styles_stars__9HoeP","starContainer":"styles_starContainer__0J5de","star":"styles_star__zp0Bb","filled":"styles_filled__U-orO"};